import script from "./ThemeSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./ThemeSelect.vue?vue&type=script&lang=ts&setup=true"

import "./ThemeSelect.vue?vue&type=style&index=0&id=50c98066&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50c98066"]])

export default __exports__